const siseva = {
    GetSolicitud: 'SISEVA/GetSolicitud',
    GetEvaluaciones: 'SISEVA/GetEvaluaciones',
    GetEvaluacionesEstimulos: 'SISEVA/GetEvaluacionesEstimulos',
    GetEvaluacionesPersona: 'SISEVA/GetEvaluacionesPersona',
    CancelarResultadoEvaluacion: 'SISEVA/CancelarResultadoEvaluacion',
    QuitarEvaluador: 'SISEVA/QuitarEvaluador',
    GetEvaluacion: 'SISEVA/GetEvaluacion',
    GetEvaluacionSoloNombresEvaluadores: 'SISEVA/GetEvaluacionSoloNombresEvaluadores',
    GetCuestionariosClasificados: 'SISEVA/GetCuestionariosClasificados',
    GetEvaluadores: 'SISEVA/GetEvaluadores',
    AsignarEvaluadores: 'SISEVA/AsignarEvaluadores',
    CrearCuestionario: 'SISEVA/CrearCuestionario',
    GetCuestionarios: 'SISEVA/GetCuestionarios',
    SetActivoFormatoCuestionario: 'SISEVA/SetActivoFormatoCuestionario',
    GetFormatoCuestionario: 'SISEVA/GetFormatoCuestionario',
    ActualizarFormatoCuestionario: 'SISEVA/ActualizarFormatoCuestionario',
    GetCompetenciasPreguntas: 'SISEVA/GetCompetenciasPreguntas',
    CrearPregunta: 'SISEVA/CrearPregunta',
    GetPreguntas: 'SISEVA/GetPreguntas',
    GetPregunta: 'SISEVA/GetPregunta',
    ActualizarPregunta: 'SISEVA/ActualizarPregunta',
    AsignarPreguntas: 'SISEVA/AsignarPreguntas',
    GetPreguntasFormatoCuestionario: 'SISEVA/GetPreguntasFormatoCuestionario',
    GetPersona: 'SISEVA/GetPersona',
    GetPersonas: 'SISEVA/GetPersonas',
    GetCuestionariosPendientes: 'SISEVA/GetCuestionariosPendientes',
    GetMisResultados: 'SISEVA/GetMisResultados',
    GetPreguntasContestadas: 'SISEVA/GetPreguntasContestadas',
    GuardarValorRespuesta: 'SISEVA/GuardarValorRespuesta',
    FinalizarCuestionario: 'SISEVA/FinalizarCuestionario',
    GetResultadoEvaluacion: 'SISEVA/GetResultadoEvaluacion',
    RealizarConteoEvaluaciones: 'SISEVA/RealizarConteoEvaluaciones',
    MarcarEvaluacionNotificada: 'SISEVA/MarcarEvaluacionNotificada',
    DesactivarEvaluacion: 'SISEVA/DesactivarEvaluacion',
    DesactivarSolicitudEvaluacion: 'SISEVA/DesactivarSolicitudEvaluacion',
    GetResultadosNivel: 'SISEVA/GetResultadosNivel',
    MarcarEvaluacionesEntregadas: 'SISEVA/MarcarEvaluacionesEntregadas',
    ReestablecerContrasena: 'SISEVA/ReestablecerContrasena',
    GetReportePorcentajeEvaluaciones: 'SISEVA/GetReportePorcentajeEvaluaciones',
    QuitarAutoevaluaciones: 'SISEVA/QuitarAutoevaluaciones',
    CalcularResultadosEvaluaciones: 'SISEVA/CalcularResultadosEvaluaciones',
    GuardarNuevaLeyendaRetroalimentacionGenerica: 'SISEVA/GuardarNuevaLeyendaRetroalimentacionGenerica',
    GetLeyendaRetroalimentacionGenerica: 'SISEVA/GetLeyendaRetroalimentacionGenerica',
    GetLeyendasRetroalimentacionGenericas: 'SISEVA/GetLeyendasRetroalimentacionGenericas',
    CambiarEstatusLeyendaRetroalimentacionGenerica: 'SISEVA/CambiarEstatusLeyendaRetroalimentacionGenerica',
    GuardarNuevaLeyendaRetroalimentacionEspecifica: 'SISEVA/GuardarNuevaLeyendaRetroalimentacionEspecifica',
    GetLeyendaRetroalimentacionEspecifica: 'SISEVA/GetLeyendaRetroalimentacionEspecifica',
    GetLeyendasRetroalimentacionEspecificas: 'SISEVA/GetLeyendasRetroalimentacionEspecificas',
    CambiarEstatusLeyendaRetroalimentacionEspecifica: 'SISEVA/CambiarEstatusLeyendaRetroalimentacionEspecifica',
    ObtenerEvaluadoresAnteriores: 'SISEVA/ObtenerEvaluadoresAnteriores',
    ObtenerPersonalEvaluacionesEstimulos: 'SISEVA/ObtenerPersonalEvaluacionesEstimulos',
    AsignarEvaluadoresEstimulos: 'SISEVA/AsignarEvaluadoresEstimulos',
    SolicitudPorBloque: 'SISEVA/SolicitudPorBloque',
    ExportarExcelEstimulos : 'SISEVA/Estimulos/ObtenerExcelRegistros',
    RegistrarEvaluacionesParaEstimulo: 'SISEVA/Estimulos/CrearEvaluaciones',
    VerificarEnProcesoEstimulos : 'SISEVA/Estimulos/ObtenerEvaluacionesEstimulos',
    CambiarEvaluacionEstimulo : 'SISEVA/Estimulos/CambiarEvaluacionEstimulo'
}

export default siseva;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/siseva/funcion/siseva.js
// module id = null
// module chunks = 